// ============================================================================
// ARABIC TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// أسئلة ممتعة للتأمل

export const funQuestionsAr = [
  {
    question: "أي عمل من أعمال محبة يسوع يلهمك أكثر في حياتك اليومية؟",
    emoji: "❤️",
    theme: "المحبة"
  },
  {
    question: "ما هو الجانب من خلق الله الذي يظهر لك عظمته أكثر؟",
    emoji: "🌟",
    theme: "الخلق"
  },
  {
    question: "ما هي الآية الكتابية التي أعطتك العزاء في وقت صعب؟",
    emoji: "🕊️",
    theme: "التعزية"
  },
  {
    question: "من هي الشخصية الكتابية التي تلهمك أكثر ولماذا؟",
    emoji: "⭐",
    theme: "الإلهام"
  },
  {
    question: "ما هي البركة التي تشكر الله عليها أكثر في حياتك؟",
    emoji: "🙏",
    theme: "الشكر"
  },
  {
    question: "أي مَثَل من أمثال يسوع أثر في رحلتك الروحية أكثر؟",
    emoji: "📖",
    theme: "التعليم"
  },
  {
    question: "ما هو الجانب من طبيعة الله الأكثر أهمية بالنسبة لك؟ (المحبة، العدل، الرحمة...)",
    emoji: "✨",
    theme: "الطبيعة"
  },
  {
    question: "متى تقوى إيمانك بطريقة غير متوقعة؟",
    emoji: "💪",
    theme: "الإيمان"
  }
];

export default funQuestionsAr;
